import React, { useState, useEffect } from "react";

import { func_validation, getTotalCountFromHeader } from "functions";
import { useLicenseControl, useOutletControl } from ".";


export function useControlChanger(props) {

    const { 
        isSuspended: isSuspended_props,
    } = props;

    // States 
    const [currentTab, setCurrentTab] = useState("License");

    const {
        getLicenseList,
        addLicenseModal,

        addLicense_status,
        resetLicense_status,
        deleteLicense_status,
        updateLicenseRemark_status,
        getLicenseList_requesting, 
        validatedLicenseList: licenseList, licenseListHeaders,

        licenseColumns,

        setIsLicenseModalVisible,
        getLicenseMenuItems,
        deleteLicenseModalDisplay,
        updateLicenseRemarkModalDisplay
    } = useLicenseControl(props);

    const {
        getOutletList,
        addOutletModal,

        addOutlet_status,
        getOutletList_requesting, 
        outletList, outletListHeaders,

        outletColumns,

        setIsOutletModalVisible
    } = useOutletControl(props);

    let totalOutlets = getTotalCountFromHeader(outletListHeaders);
    let totalLicenses = getTotalCountFromHeader(licenseListHeaders);
    // useEffect(() => {
    //     getLicenseList(null, totalLicenses);
    // }, [totalLicenses]);
    useEffect(() => {
        getOutletList(null, totalOutlets);
    }, [totalOutlets])

    let addControlModals = [(<div key={0}>{addOutletModal}</div>), (<div key={1}>{addLicenseModal}</div>), (<div key={2}>{deleteLicenseModalDisplay}</div>), (<div key={3}>{updateLicenseRemarkModalDisplay}</div>)];
    let addControlButtonText, addControlButtonDisable, tableData, getTableList, isTableLoading, isTableRefreshRequired, setModalVisibility, isCheckboxRequired, isCheckboxColumnFirst, getMenuItems;
    let columns;
    switch (currentTab) {
        case "Outlet": 
            getTableList = getOutletList;

            isTableRefreshRequired = addOutlet_status;
            isTableLoading = getOutletList_requesting;
            tableData = outletList;

            columns = outletColumns;

            addControlButtonText = "Add Outlet";
            addControlButtonDisable = false;
            setModalVisibility = setIsOutletModalVisible;
            isCheckboxRequired = false;
            isCheckboxColumnFirst = false;
            break;
        case "License":
        default:
            getTableList = getLicenseList;

            isTableRefreshRequired = addLicense_status || resetLicense_status || deleteLicense_status || updateLicenseRemark_status;
            isTableLoading = getLicenseList_requesting;
            tableData = licenseList;

            columns = licenseColumns;

            addControlButtonText = "Add License";
            addControlButtonDisable = isSuspended_props;
            setModalVisibility = setIsLicenseModalVisible;
            isCheckboxRequired = true;
            isCheckboxColumnFirst = true;
            getMenuItems = getLicenseMenuItems;
            break;
    }
    
    return {
        currentTab, setCurrentTab,

        addControlButtonText, addControlButtonDisable,

        columns,

        tableData,
        getTableList,
        addControlModals,

        isTableLoading,
        isTableRefreshRequired,

        totalOutlets,
        totalLicenses,

        setModalVisibility,
        isCheckboxRequired, isCheckboxColumnFirst,
        getMenuItems,
    }
}